import React from 'react';
import { Container, Box, Typography, Button, Stack, Paper } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function NoProfileFound() {
  const history = useHistory();
  const location = useLocation();
  const isFromEcs2 = location.hash === '#ecs2';

  const handleGoBack = () => {
    if (isFromEcs2) {
      window.close();
    } else {
      history.push('/');
    }
  };

  return (
    <Container 
      maxWidth="sm" 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '100vh',
        paddingY: { xs: 1, sm: 2, md: 3 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          padding: { xs: '1.5rem', sm: '2rem', md: '3rem' },
          textAlign: 'center',
          backgroundColor: '#ffffff',
          borderRadius: { xs: '12px', sm: '16px' },
          boxShadow: { xs: '0 2px 4px rgba(0, 0, 0, 0.08)', sm: '0 4px 8px rgba(0, 0, 0, 0.1)' },
        }}
      >
        <Box
          sx={{
            fontSize: { xs: 32, sm: 48, md: 64 },
            lineHeight: 1,
            marginBottom: { xs: 1.5, sm: 2, md: 3 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          aria-hidden
        >
          🔍
        </Box>

        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 700,
            marginBottom: { xs: 1, sm: 1.5, md: 2 },
            color: '#1a1a1a',
            fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.5rem' },
            lineHeight: 1.2,
          }}
        >
          No Profile Found
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            marginBottom: { xs: 2.5, sm: 3, md: 4 },
            fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
            lineHeight: 1.6,
            maxWidth: '500px',
            paddingX: { xs: 0.5, sm: 1 },
          }}
        >
          We couldn't find a profile that matches your request.
        </Typography>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1.5, sm: 2, md: 2.5 }}
          sx={{
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="large"
            startIcon={<ArrowBackIcon sx={{ display: { xs: 'none', sm: 'block' } }} />}
            onClick={handleGoBack}
            aria-label="Go Back to New App"
            sx={{
              paddingX: { xs: 2, sm: 3 },
              paddingY: { xs: 1, sm: 1.5 },
              textTransform: 'none',
              fontSize: { xs: '0.95rem', sm: '1rem' },
              fontWeight: 600,
              borderRadius: '8px',
              border: '2px solid',
              transition: 'all 0.3s ease',
              width: { xs: '100%', sm: 'auto' },
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                borderColor: 'primary.main',
                transform: { xs: 'none', sm: 'translateY(-2px)' },
                boxShadow: { xs: 'none', sm: '0 4px 12px rgba(0, 0, 0, 0.12)' },
              },
              '&:active': {
                transform: 'translateY(0)',
              },
            }}
          >
            Go Back
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}